
import Vue from 'vue';
import { RunnitNode, RunnitNodeRunResult } from '@run-diffusion/shared';
import RunnitImage from '@/views/Runnits/RunnitImage.vue';
import BaseButton from '@/components/base/BaseButton.vue';

export default Vue.extend({
	name: 'NodeNavigationPanel',
	components: {
		RunnitImage,
		BaseButton,
	},
	props: {
		prefillingAllTools: {
			type: Boolean,
			default: false,
		},
		selectedNodes: {
			type: Array as () => RunnitNode[],
			required: true,
		},
		selectedNodeId: {
			type: String as () => string | null,
			default: null,
		},
		selectedResults: {
			type: Array as () => Array<{
				templateNodeId: string
				sourceNodeRunId: string
				resultUuid: string
				result: RunnitNodeRunResult
			}>,
			default: () => [],
		},
	},
	computed: {
		resultsByNodeId (): Record<string, Array<{
			templateNodeId: string
			sourceNodeRunId: string
			resultUuid: string
			result: RunnitNodeRunResult
		}>> {
			const grouped: Record<string, Array<{
				templateNodeId: string
				sourceNodeRunId: string
				resultUuid: string
				result: RunnitNodeRunResult
			}>> = {};

			for (const result of this.selectedResults) {
				const nodeId = result.templateNodeId;
				if (!grouped[nodeId]) {
					grouped[nodeId] = [];
				}
				grouped[nodeId].push(result);
			}

			return grouped;
		},
	},
	methods: {
		getSelectedCountForNode (nodeId: string): number {
			return this.resultsByNodeId[nodeId]?.length || 0;
		},
	},
});
